export const pGetVerifyCode = Object.seal({
    email: ''
})
